export const USERNAME_PATTERN = /^[A-Za-z0-9_]{3,20}$/;

export const normalizeUsernameForDisplay = (value) => {
    if (typeof value !== "string") {
        return null;
    }

    const trimmed = value.trim();
    return USERNAME_PATTERN.test(trimmed) ? trimmed : null;
};

export const normalizeUsernameForLookup = (value) => {
    const username = normalizeUsernameForDisplay(value);
    return username ? username.toLowerCase() : null;
};
